import { render, staticRenderFns } from "./addSource.vue?vue&type=template&id=32ae9782&"
import script from "./addSource.vue?vue&type=script&lang=js&"
export * from "./addSource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32ae9782')) {
      api.createRecord('32ae9782', component.options)
    } else {
      api.reload('32ae9782', component.options)
    }
    module.hot.accept("./addSource.vue?vue&type=template&id=32ae9782&", function () {
      api.rerender('32ae9782', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/info/source/addSource.vue"
export default component.exports